import ConfirmationModal from "~/common/components/ConfirmationModal";
import { LinkButton } from "~/common/components/Link";
import { requestConfirmation } from "~/common/utils/ModalService";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { type WishlistModel } from "~/features/wishlist/types/model";
import { useDispatch } from "react-redux";
import { removeSelectedWishlist } from "~/features/wishlist/redux/actions";
import { useTranslation } from "react-i18next";

interface DeleteWishlistButton {
  wishlist: WishlistModel;
}
export const DeleteWishlistButton = ({ wishlist }: DeleteWishlistButton) => {
  const { t } = useTranslation();
  const label = t("wishlistPage.deleteWishlist", { name: wishlist.name });

  const dispatch = useDispatch();

  const onClick = async () => {
    const confirmation = await requestConfirmation(({ onConfirm, onCancel }) => (
      <ConfirmationModal
        label={label}
        okLabel={t("common.yes")}
        cancelLabel={t("common.no")}
        onCancel={onCancel}
        onOk={onConfirm}
      />
    ));
    if (confirmation) {
      dispatch(removeSelectedWishlist());
    }
  };

  return (
    <LinkButton onClick={onClick} data-test-id={"btn-delete-wishlist"} iconBefore={<Icon type={IconType.Bin} />}>
      {t("wishlistPage.button.deleteProduct")}
    </LinkButton>
  );
};
